<template>
  <div class="slidewindow" :class="{'slidewindow_spaced': spaced, 'slidewindow_debug':debug}">
    <div class="slidewindow__content" :style="{'transform': `translateX(${100 * (-slidenumber)}%)`}">
      <slot />
    </div>
    <div class="debugwindow" v-if="debug">{{debugtext}}</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

  export default {
    props: {
      slidenumber: {type: Number, default: 0}
    },
    computed: {
      ...mapState(['debug', 'debugtext']),
      spaced(){
        return this.slidenumber == 0 ||
               this.slidenumber == 2 ||
               this.slidenumber == 3 ||
               this.slidenumber == 4
      }
    }
  }
</script>

<style lang="sass">
.debugwindow
  padding: 5px
  position: absolute
  bottom: 0
  background: white
  left: 50%
  border: 2px solid black
  max-width: 1200px
  transform: translateX(-50%)
  max-height: 100%
  overflow: auto
  width: 100%
  pointer-events: auto !important
  z-index: 2140000000 !important
  white-space: pre
.slidewindow
  letter-spacing: globalvars.$onespacing
  position: relative
  z-index: 2
  //overflow: hidden
  pointer-events: none
  padding-left: 32px
  padding-right: 32px
  margin-left: -32px
  margin-right: -32px
  @include for-mob
    padding-left: 16px
    padding-right: 16px
    margin-left: -16px
    margin-right: -16px
  &_spaced
    padding-bottom: 150px
    margin-bottom: -150px


  &__content
    pointer-events: auto
    width: 100%
    display: flex
    overflow: visible
    transition: .6s ease
    >*
      width: 100%
      height: 100%
      min-width: 100%
      max-width: 100%
</style>